import { CrpInterface } from '@/core/domain/car-rental-policy/models/crp.model';
import { CrpRepository } from '@/core/domain/car-rental-policy/repositories/crp.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { crpInternational } from '../../core/domain/car-rental-policy/models/crp-body';

@Injectable({
    providedIn: 'root',
})
export class CrpImplRepository extends CrpRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override postCrp(
        crpInternational: crpInternational,
    ): Observable<CrpInterface> {
        return this.httpClient
            .post<CrpInterface>(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.crp,
                ].join('/'),
                crpInternational,
            )
            .pipe(
                switchMap((crpResponse: CrpInterface) => {
                    const crp: CrpInterface = {
                        type: crpResponse.type,
                        action: crpResponse.action,
                        notifications: crpResponse.notifications,
                        data: crpResponse.data,
                    };

                    return of(crp);
                }),
            );
    }
}
